import NoImage from "../../../assets/No image.png";
import SC from "./style";
import InnoIcons from "InnoUI/innoicons";
import theme from "theme";
import TooltipText from "components/TooltipText";
import { getCountryByID } from "utils/helper";

const ProjectCard = (props) => {
  const { data, onClick, handleInfoClick } = props;

  return (
    <div style={{ padding: "4px" }}>
      <SC.Cardstyle onClick={onClick}>
        <div
          style={{ position: "absolute", top: "1rem", left: "1rem", zIndex: 1 }}
        >
          <p
            style={{
              fontWeight: "600",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              color: data.status == 1 ? "#10b981" : "#ef4444",
              fontSize: "0.75rem",
              padding: "0.25rem 0.75rem",
              background:
                data.status == 1
                  ? "rgba(16, 185, 129, 0.1)"
                  : "rgba(239, 68, 68, 0.1)",
              borderRadius: "1rem",
              border:
                data.status == 1
                  ? "1px solid rgba(16, 185, 129, 0.2)"
                  : "1px solid rgba(239, 68, 68, 0.2)",
              display: "inline-block",
              margin: 0,
            }}
          >
            {data.status == 1 ? "Active" : "Inactive"}
          </p>
        </div>
        <div style={{ marginTop: "2rem" }}>
          <SC.logoBoxStyle>
            <SC.ImageDiv>
              <SC.ImageContainer
                src={data.logoImage || NoImage}
                alt={""}
                style={{
                  border: `1.5px solid ${theme.colors.greyColor}`,
                  borderRadius: "3px",
                }}
              />
            </SC.ImageDiv>
            <div
              style={{
                width: "100%",
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <span
                title={data?.propertyName || ""}
                style={{
                  fontWeight: "700",
                  paddingBlock: "0px",
                  marginBlock: "0px",
                  fontSize: "1.125rem",
                  background: theme.gradient.themeGradient,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  lineHeight: "1.2",
                  marginBottom: "0.5rem",
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                  whiteSpace: "normal",
                }}
              >
                {data?.propertyName || ""}
              </span>

              <span
                title={getCountryByID(data?.countryName || "")}
                style={{
                  fontSize: "0.875rem",
                  color: "#6b7280",
                  fontWeight: "500",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {getCountryByID(data?.countryName || "")}
              </span>
            </div>
          </SC.logoBoxStyle>
        </div>
        <SC.infoBoxStyle>
          <span
            title={data.email || "N/A"}
            style={{
              color: "#374151",
              fontSize: "0.875rem",
              fontWeight: "600",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              minWidth: 0,
              overflow: "hidden",
            }}
          >
            <InnoIcons.PersonRoundedIcon
              style={{ fontSize: "1.75rem", color: "#E36E00", flexShrink: 0 }}
            />
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                minWidth: 0,
              }}
            >
              {data.email || "N/A"}
            </span>
          </span>
        </SC.infoBoxStyle>
      </SC.Cardstyle>
    </div>
  );
};

export default ProjectCard;
